<sdps-divider variation="secondary"></sdps-divider>
<span id="section-title">Transaction details</span>
<mm-banners id="it-service-error-banner" data-testid="transactionDetailsInternalTransfer_serverError" *ngIf="showServerError && !hasInternationalFedTaxError" [bannerText]="[serverErrorText]" [type]="'error'" ></mm-banners>
<mm-banners id="it-download-request-form-error-banner" *ngIf="downloadRequestFormError" [type]="'error'" [downloadCheckJournalRequestForm]="true"></mm-banners>
<form [formGroup]="itInputForm">
  <div class="column">
      <div class="account-container">
        <mm-it-to-account-number
          [parentForm]="itInputForm"
          [disabled]="(useStandingAuth$ | async) || null"
          [info$]="itInfo$"
          [toAccountState$]="toAccountState$"
          (resetForm)="resetForm()"
          [isRecurringTransaction]="isRecurringTransaction">
        </mm-it-to-account-number>
      </div>
      <mm-banners *ngIf="is401k()" [htmlStr]="[warningText401kIneligableForEauth]" [type]="'warning'"></mm-banners>
      <fieldset>
        <div *ngIf="isPositionsTransaction(transferType); else notPositionsTransaction">
          <div *ngIf="!isInvalidDigitalToPdfToAccount()" class="input-container">
            <span class="sdps-text-nowrap">
              <label>Process Date</label>
              <mm-tooltip [position]="'right'" [containsLink]="false"
                id="positions-process-date-tooltip">
                <tooltip-content>
                  <div>{{positionProcessDateToolTipMessage}}</div>
                </tooltip-content>
                <tooltip-trigger-element>
                  <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
                </tooltip-trigger-element>
              </mm-tooltip>
            </span>
            <input type="text" value={{currentDate()}} disabled class="sdps-input sdps-input--small" id="border_Color">
          </div>
        </div>
        <ng-template #notPositionsTransaction>
          <div class="big-bottom-spacer process-date">
            <mm-date-picker-control [label]="processDateLabel" formControlName="processDate" [parentForm]="itInputForm"
              [id]="'process-date-picker'" [minDate]="minDate" [maxDate]="maxDate" [disableWeekends]="!isRecurringTransaction"
              [formControlValidators]="!isRecurringTransaction ? processDateValidators : recurringProcessDateValidators" [disableDateSelect]="disableDateSelect">
            </mm-date-picker-control>
          </div>
        </ng-template>
        <div class="process-date-continued">
          <div class="big-bottom-spacer">
            <mm-recurring-frequency-selector *ngIf="isRecurringTransaction" [parentForm]="recurringFieldsFormGroup"
              [frequencyList]="this.itInfo.recurringFields.frequencyList" data-testid="frequencyOfRecurring" id="recurringFrequencySelector-It">
            </mm-recurring-frequency-selector>
          </div>
          <div *ngIf="isRecurringTransaction" formGroupName="recurringFieldsFormGroup" class="second-process-date-end-date">
            <div class="big-bottom-spacer">
              <mm-date-picker-control *ngIf="recurringFrequency?.value === 'SEMIMTH'" formControlName="secondProcessDate" id="secondProcessDate"
                [label]="secondProcessDateLabel" [parentForm]="recurringFieldsFormGroup" [minDate]="minDate"
                [disableWeekends]="!isRecurringTransaction" [formControlValidators]="secondProcessDateValidators"
                (newValueEvent)="onSecondProcessDateChange($event)" [id]="'second-process-date-picker'">
              </mm-date-picker-control>
            </div>
            <div class="big-bottom-spacer">
              <mm-date-picker-control *ngIf="recurringFrequency?.valid" formControlName="endDate" id="endDate" [label]="endDateLabel"
                [minDate]="minDate" [disableWeekends]="false" [formControlValidators]="endDateValidators"
                [showOptionalLabel]="true" [parentForm]="recurringFieldsFormGroup" (newValueEvent)="onEndDateChange($event)"
                [id]="'end-date-picker'">
              </mm-date-picker-control>
            </div>
          </div>
        </div>
      </fieldset>
  </div>

  <div *ngIf="!isInvalidDigitalToPdfToAccount()" class="row" id="{{showCostBasisMethod ? 'costBasisMethod' : ''}}">
    <fieldset>
      <div>
        <mm-radio-control *ngIf="this.showCostBasisMethod" [parentForm]="itInputForm"
          [radioModel]="costBasisMethodModel">
        </mm-radio-control>
      </div>
    </fieldset>
  </div>
  <positions-lots-table [reviewConfirmationPage]="false" *ngIf="isPositionsTransaction(transferType) && !isInvalidDigitalToPdfToAccount()"
    [showSelectPositionError]="displayPositionsWarning && isPositionsTransaction(transferType)" [maxLotsWarningMessage]="maxLotsWarningMessage" [maxLotsWarning]="maxLotsWarning" [isOneTimeTotalDist]="isOneTimeTotalDist"></positions-lots-table>
  <fieldset>
    <div *ngIf="(!isInvalidDigitalToPdfToAccount() && isPositionsTransaction(this.transferType)) || 
      !isPositionsTransaction(this.transferType)" class="transaction-details-fields">
      <div class="row" *ngIf="transferType !== 'positions'">
            <mm-amount-field [autoCalculateRmd$]="autoCalculateRmd$" [iraFields]="iraFields" [parentForm]="itInputForm"
              [payIncome$]="payIncome$" [frequency$]="frequency$"
              class="big-bottom-spacer">
            </mm-amount-field>
            <mm-amount-type-selector *ngIf="iraFields.isIraTransaction" [parentForm]="itInputForm"
              [prefilledValue]="amountTypeSelection" [autoCalculateRmd$]="autoCalculateRmd$" [grossNetRadioEditContainer]="true"
              [payIncome$]="payIncome$" [distributionReason$]="distributionReason$" [isFirstPartyIraToIraJournal$]="isFirstPartyIraToIraJournal$">
            </mm-amount-type-selector>
      </div>
      <div class="row" *ngIf="recurringFrequency?.value === 'LASTBIZ'">
        <mm-pay-income-selector
            [parentForm]="recurringFieldsFormGroup" class="big-bottom-spacer">
          </mm-pay-income-selector>
      </div>
      <div *ngIf="itInfo.iraContributionTypeMap.length > 0">
        <div id="itTransactionDetails_IraContributionSelectRow" [ngClass]="!isIra && (showWarningIRA || defaultWarningIRA) ? 'col-3' : 'col-1'">
          <mm-select-dropdown-control class="big-bottom-spacer" id="itTransactionDetails_IraContributionSelect"
            [parentForm]="itInputForm" label="'IRA contribution type'" [selectModel]="iraContributionTypeModel"
            [tooltipVerbiage]="contributionTypeTooltip" (change)="onChange($event)" (defaultIRA)="defaultIRAWarning($event)"
            [isInternalTransfer]="isInternalTransfer()">
          </mm-select-dropdown-control>
        </div>
        <div *ngIf="!isIra && (showWarningIRA || defaultWarningIRA)">
          <div id="warning">
            <div id="warning-icon" data-testid="warning-icon" class="warning-icon-ira"></div>
            <span id="warning-text">IRS 60-day rollover requirement</span>
          </div>
          <mm-banners [htmlStr]="[iraRolloverContributionTypeWarning]" [type]="'warning'"></mm-banners>
        </div>
      </div>
      <hr *ngIf="displayTaxWithholdingsFields">
      <mm-create-request-tax-withholdings *ngIf="displayTaxWithholdingsFields" [parentForm]="itInputForm"
        [taxWithholdings]="(taxWithholdingFields$ | async)!"
        [taxWithholdingsFormGroupDetails]="taxWithholdingsFormGroupDetails"
        [distributionReasonMap$]="distributionReasonMap$" [distributionReason$]="distributionReason$"
        [distributionReasonTooltip]="distributionReasonTooltip" [isPositionsTransaction]="isPositions" class="big-bottom-spacer">
      </mm-create-request-tax-withholdings>
      <hr *ngIf="showTrustFields">
      <mm-trust-fields id="itTransactionDetails_ trustFields" class="itTransactionDetails_trustFields" *ngIf="showTrustFields" [parentForm]="itInputForm"
        [showPaidFor]="true" [availableCash]="availableCash" [overdraftRulesFutureDate]="overdraftRulesFutureDate"
        [datePickerControlName]="controlNames.processDate" [displayToTrustFields]="isToTrustAccount"
        [displayFromTrustFields]="isFromPtrsAccount" [toAccountControlNames]="toAccountControlNames">
      </mm-trust-fields>
    </div>
  </fieldset>
</form>
